module.exports = __webpack_public_path__ + "static/img/content.e3cbbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/detail/content.png
// module id = rYUl
// module chunks = 6